module.exports = __webpack_public_path__ + "static/media/twitterIcon.27480480.svg";